import _createForOfIteratorHelper from "/home/runner/work/eevsalumni.com/eevsalumni.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/runner/work/eevsalumni.com/eevsalumni.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/eevsalumni.com/eevsalumni.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/runner/work/eevsalumni.com/eevsalumni.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/home/runner/work/eevsalumni.com/eevsalumni.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/eevsalumni.com/eevsalumni.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isValidElement, useRef, useState, useCallback, useEffect, createContext, useContext, createElement, cloneElement, Fragment } from 'react';

var isNullOrUndefined = function isNullOrUndefined(value) {
  return value == null;
};

var isArray = function isArray(value) {
  return Array.isArray(value);
};

var isObjectType = function isObjectType(value) {
  return typeof value === 'object';
};

var isObject = function isObject(value) {
  return !isNullOrUndefined(value) && !isArray(value) && isObjectType(value);
};

var isHTMLElement = function isHTMLElement(value) {
  return isObject(value) && value.nodeType === Node.ELEMENT_NODE;
};

var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit'
};
var VALUE = 'value';
var UNDEFINED = 'undefined';
var EVENTS = {
  BLUR: 'blur',
  CHANGE: 'change',
  INPUT: 'input'
};
var SELECT = 'select';
var INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};
var REGEX_IS_DEEP_PROP = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var REGEX_IS_PLAIN_PROP = /^\w*$/;
var REGEX_PROP_NAME = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var REGEX_ESCAPE_CHAR = /\\(\\)?/g;
var REGEX_ARRAY_FIELD_INDEX = /[\d+]/g;

function attachEventListeners(_ref) {
  var ref = _ref.field.ref,
      handleChange = _ref.handleChange,
      isRadioOrCheckbox = _ref.isRadioOrCheckbox;

  if (isHTMLElement(ref) && handleChange) {
    ref.addEventListener(isRadioOrCheckbox ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
    ref.addEventListener(EVENTS.BLUR, handleChange);
  }
}

var isKey = function isKey(value) {
  return !isArray(value) && (REGEX_IS_PLAIN_PROP.test(value) || !REGEX_IS_DEEP_PROP.test(value));
};

var stringToPath = function stringToPath(string) {
  var result = [];
  string.replace(REGEX_PROP_NAME, function (match, number, quote, string) {
    result.push(quote ? string.replace(REGEX_ESCAPE_CHAR, '$1') : number || match);
  });
  return result;
};

function set(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath(path);
  var length = tempPath.length;
  var lastIndex = length - 1;

  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;

    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject(objValue) || isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }

    object[key] = newValue;
    object = object[key];
  }

  return object;
}

var transformToNestObject = function transformToNestObject(data) {
  return Object.entries(data).reduce(function (previous, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    if (!isKey(key)) {
      set(previous, key, value);
      return previous;
    }

    return Object.assign(Object.assign({}, previous), _defineProperty({}, key, value));
  }, {});
};

var isUndefined = function isUndefined(val) {
  return val === undefined;
};

var get = function get(obj, path, defaultValue) {
  var result = path.split(/[,[\].]+?/).filter(Boolean).reduce(function (result, key) {
    return isNullOrUndefined(result) ? result : result[key];
  }, obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};

var focusOnErrorField = function focusOnErrorField(fields, fieldErrors) {
  for (var key in fields) {
    if (get(fieldErrors, key)) {
      var field = fields[key];

      if (field) {
        if (field.ref.focus) {
          field.ref.focus();
          break;
        } else if (field.options) {
          field.options[0].ref.focus();
          break;
        }
      }
    }
  }
};

var removeAllEventListeners = function removeAllEventListeners(ref, validateWithStateUpdate) {
  if (isHTMLElement(ref) && ref.removeEventListener) {
    ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
  }
};

var isRadioInput = function isRadioInput(element) {
  return element.type === 'radio';
};

var isCheckBoxInput = function isCheckBoxInput(element) {
  return element.type === 'checkbox';
};

function isDetached(element) {
  if (!element) {
    return true;
  }

  if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
    return false;
  }

  return isDetached(element.parentNode);
}

var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && !Object.keys(value).length;
};

function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

function baseGet(object, path) {
  var updatePath = isKey(path) ? [path] : castPath(path);
  var length = path.length;
  var index = 0;

  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }

  return index == length ? object : undefined;
}

function baseSlice(array, start, end) {
  var index = -1;
  var length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}

function parent(object, path) {
  return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
}

function baseUnset(object, path) {
  var updatePath = isKey(path) ? [path] : castPath(path);
  var childObject = parent(object, updatePath);
  var key = updatePath[updatePath.length - 1];
  var result = !(childObject != null) || delete childObject[key];
  var previousObjRef = undefined;

  for (var k = 0; k < updatePath.slice(0, -1).length; k++) {
    var index = -1;
    var objectRef = undefined;
    var currentPaths = updatePath.slice(0, -(k + 1));
    var currentPathsLength = currentPaths.length - 1;

    if (k > 0) {
      previousObjRef = object;
    }

    while (++index < currentPaths.length) {
      var item = currentPaths[index];
      objectRef = objectRef ? objectRef[item] : object[item];

      if (currentPathsLength === index) {
        if (isObject(objectRef) && isEmptyObject(objectRef) || isArray(objectRef) && !objectRef.filter(function (data) {
          return isObject(data) && !isEmptyObject(data);
        }).length) {
          previousObjRef ? delete previousObjRef[item] : delete object[item];
        }
      }

      previousObjRef = objectRef;
    }
  }

  return result;
}

function unset(object, paths) {
  paths.forEach(function (path) {
    baseUnset(object, path);
  });
  return object;
}

var isSameRef = function isSameRef(fieldValue, ref) {
  return fieldValue && fieldValue.ref === ref;
};

function findRemovedFieldAndRemoveListener(fields, handleChange, field, forceDelete) {
  var ref = field.ref,
      _field$ref = field.ref,
      name = _field$ref.name,
      type = _field$ref.type,
      mutationWatcher = field.mutationWatcher;
  var fieldValue = fields[name];

  if (!type) {
    delete fields[name];
    return;
  }

  if ((isRadioInput(ref) || isCheckBoxInput(ref)) && fieldValue) {
    var options = fieldValue.options;

    if (isArray(options) && options.length) {
      options.filter(Boolean).forEach(function (option, index) {
        var ref = option.ref,
            mutationWatcher = option.mutationWatcher;

        if (ref && isDetached(ref) && isSameRef(option, ref) || forceDelete) {
          removeAllEventListeners(ref, handleChange);

          if (mutationWatcher) {
            mutationWatcher.disconnect();
          }

          unset(options, ["[".concat(index, "]")]);
        }
      });

      if (options && !options.filter(Boolean).length) {
        delete fields[name];
      }
    } else {
      delete fields[name];
    }
  } else if (isDetached(ref) && isSameRef(fieldValue, ref) || forceDelete) {
    removeAllEventListeners(ref, handleChange);

    if (mutationWatcher) {
      mutationWatcher.disconnect();
    }

    delete fields[name];
  }
}

var defaultReturn = {
  isValid: false,
  value: ''
};

var getRadioValue = function getRadioValue(options) {
  return isArray(options) ? options.reduce(function (previous, option) {
    return option && option.ref.checked ? {
      isValid: true,
      value: option.ref.value
    } : previous;
  }, defaultReturn) : defaultReturn;
};

var getMultipleSelectValue = function getMultipleSelectValue(options) {
  return _toConsumableArray(options).filter(function (_ref4) {
    var selected = _ref4.selected;
    return selected;
  }).map(function (_ref5) {
    var value = _ref5.value;
    return value;
  });
};

var isFileInput = function isFileInput(element) {
  return element.type === 'file';
};

var isMultipleSelect = function isMultipleSelect(element) {
  return element.type === "".concat(SELECT, "-multiple");
};

var isEmptyString = function isEmptyString(value) {
  return value === '';
};

var defaultResult = {
  value: false,
  isValid: false
};
var validResult = {
  value: true,
  isValid: true
};

var getCheckboxValue = function getCheckboxValue(options) {
  if (isArray(options)) {
    if (options.length > 1) {
      var values = options.filter(function (option) {
        return option && option.ref.checked;
      }).map(function (_ref6) {
        var value = _ref6.ref.value;
        return value;
      });
      return {
        value: values,
        isValid: !!values.length
      };
    }

    var _options$0$ref = options[0].ref,
        checked = _options$0$ref.checked,
        value = _options$0$ref.value,
        attributes = _options$0$ref.attributes;
    return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || isEmptyString(value) ? validResult : {
      value: value,
      isValid: true
    } : validResult : defaultResult;
  }

  return defaultResult;
};

function getFieldValue(fields, ref) {
  var name = ref.name,
      value = ref.value;
  var field = fields[name];

  if (isFileInput(ref)) {
    return ref.files;
  }

  if (isRadioInput(ref)) {
    return field ? getRadioValue(field.options).value : '';
  }

  if (isMultipleSelect(ref)) {
    return getMultipleSelectValue(ref.options);
  }

  if (isCheckBoxInput(ref)) {
    return field ? getCheckboxValue(field.options).value : false;
  }

  return value;
}

var isString = function isString(value) {
  return typeof value === 'string';
};

var getFieldsValues = function getFieldsValues(fields, search) {
  var output = {};

  var _loop = function _loop(name) {
    if (isUndefined(search) || (isString(search) ? name.startsWith(search) : isArray(search) ? search.find(function (data) {
      return name.startsWith(data);
    }) : search && search.nest)) {
      output[name] = getFieldValue(fields, fields[name].ref);
    }
  };

  for (var name in fields) {
    _loop(name);
  }

  return output;
};

var compareObject = function compareObject() {
  var objectA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var objectB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var objectAKeys = Object.keys(objectA);
  var objectBKeys = Object.keys(objectB);
  return objectAKeys.length === objectBKeys.length && objectAKeys.every(function (key) {
    return objectB[key] && objectB[key] === objectA[key];
  });
};

var isSameError = function isSameError(error, _ref7) {
  var type = _ref7.type,
      types = _ref7.types,
      message = _ref7.message;
  return isObject(error) && error.type === type && error.message === message && compareObject(error.types, types);
};

function shouldRenderBasedOnError(_ref8) {
  var errors = _ref8.errors,
      name = _ref8.name,
      error = _ref8.error,
      validFields = _ref8.validFields,
      fieldsWithValidation = _ref8.fieldsWithValidation;
  var isFieldValid = isEmptyObject(error);
  var isFormValid = isEmptyObject(errors);
  var currentFieldError = get(error, name);
  var existFieldError = get(errors, name);

  if (isFieldValid && validFields.has(name) || existFieldError && existFieldError.isManual) {
    return false;
  }

  if (isFormValid !== isFieldValid || !isFormValid && !existFieldError || isFieldValid && fieldsWithValidation.has(name) && !validFields.has(name)) {
    return true;
  }

  return currentFieldError && !isSameError(existFieldError, currentFieldError);
}

var isRegex = function isRegex(value) {
  return value instanceof RegExp;
};

var getValueAndMessage = function getValueAndMessage(validationData) {
  var isValueMessage = function isValueMessage(value) {
    return isObject(value) && !isRegex(value);
  };

  return isValueMessage(validationData) ? validationData : {
    value: validationData,
    message: ''
  };
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

var isMessage = function isMessage(value) {
  return isString(value) || isObject(value) && isValidElement(value);
};

function getValidateError(result, ref) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';

  if (isMessage(result) || isBoolean(result) && !result) {
    return {
      type: type,
      message: isMessage(result) ? result : '',
      ref: ref
    };
  }
}

var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
  if (validateAllFieldCriteria) {
    var error = errors[name];
    return Object.assign(Object.assign({}, error), {
      types: Object.assign(Object.assign({}, error && error.types ? error.types : {}), _defineProperty({}, type, message || true))
    });
  }

  return {};
};

var validateField = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldsRef, validateAllFieldCriteria, _ref9) {
    var ref, _ref9$ref, type, value, name, options, required, maxLength, minLength, min, max, pattern, validate, _a, fields, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref11, requiredValue, requiredMessage, exceedMax, exceedMin, _getValueAndMessage, maxValue, maxMessage, _getValueAndMessage2, minValue, minMessage, valueNumber, valueDate, _getValueAndMessage3, maxLengthValue, maxLengthMessage, _getValueAndMessage4, minLengthValue, minLengthMessage, inputLength, _exceedMax, _exceedMin, _getValueAndMessage5, patternValue, patternMessage, fieldValue, validateRef, result, validateError, validationResult, _i, _Object$entries, _Object$entries$_i, key, validateFunction, validateResult, _validateError;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ref = _ref9.ref, _ref9$ref = _ref9.ref, type = _ref9$ref.type, value = _ref9$ref.value, name = _ref9$ref.name, options = _ref9.options, required = _ref9.required, maxLength = _ref9.maxLength, minLength = _ref9.minLength, min = _ref9.min, max = _ref9.max, pattern = _ref9.pattern, validate = _ref9.validate;
            fields = fieldsRef.current;
            error = {};
            isRadio = isRadioInput(ref);
            isCheckBox = isCheckBoxInput(ref);
            isRadioOrCheckbox = isRadio || isCheckBox;
            isEmpty = isEmptyString(value);
            appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

            getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
              var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
              var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
              var message = exceedMax ? maxLengthMessage : minLengthMessage;
              error[name] = Object.assign({
                type: exceedMax ? maxType : minType,
                message: message,
                ref: ref
              }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));

              if (!validateAllFieldCriteria) {
                return error;
              }
            };

            if (!(required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid))) {
              _context.next = 15;
              break;
            }

            _ref11 = isMessage(required) ? {
              value: !!required,
              message: required
            } : getValueAndMessage(required), requiredValue = _ref11.value, requiredMessage = _ref11.message;

            if (!requiredValue) {
              _context.next = 15;
              break;
            }

            error[name] = Object.assign({
              type: INPUT_VALIDATION_RULES.required,
              message: requiredMessage,
              ref: isRadioOrCheckbox ? (_a = fields[name].options) === null || _a === void 0 ? void 0 : _a[0].ref : ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, requiredMessage));

            if (validateAllFieldCriteria) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", error);

          case 15:
            if (!(!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
              _context.next = 23;
              break;
            }

            _getValueAndMessage = getValueAndMessage(max), maxValue = _getValueAndMessage.value, maxMessage = _getValueAndMessage.message;
            _getValueAndMessage2 = getValueAndMessage(min), minValue = _getValueAndMessage2.value, minMessage = _getValueAndMessage2.message;

            if (type === 'number' || !type && !isNaN(value)) {
              valueNumber = ref.valueAsNumber || parseFloat(value);

              if (!isNullOrUndefined(maxValue)) {
                exceedMax = valueNumber > maxValue;
              }

              if (!isNullOrUndefined(minValue)) {
                exceedMin = valueNumber < minValue;
              }
            } else {
              valueDate = ref.valueAsDate || new Date(value);

              if (isString(maxValue)) {
                exceedMax = valueDate > new Date(maxValue);
              }

              if (isString(minValue)) {
                exceedMin = valueDate < new Date(minValue);
              }
            }

            if (!(exceedMax || exceedMin)) {
              _context.next = 23;
              break;
            }

            getMinMaxMessage(!!exceedMax, maxMessage, minMessage, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

            if (validateAllFieldCriteria) {
              _context.next = 23;
              break;
            }

            return _context.abrupt("return", error);

          case 23:
            if (!(isString(value) && !isEmpty && (maxLength || minLength))) {
              _context.next = 33;
              break;
            }

            _getValueAndMessage3 = getValueAndMessage(maxLength), maxLengthValue = _getValueAndMessage3.value, maxLengthMessage = _getValueAndMessage3.message;
            _getValueAndMessage4 = getValueAndMessage(minLength), minLengthValue = _getValueAndMessage4.value, minLengthMessage = _getValueAndMessage4.message;
            inputLength = value.toString().length;
            _exceedMax = !isNullOrUndefined(maxLengthValue) && inputLength > maxLengthValue;
            _exceedMin = !isNullOrUndefined(minLengthValue) && inputLength < minLengthValue;

            if (!(_exceedMax || _exceedMin)) {
              _context.next = 33;
              break;
            }

            getMinMaxMessage(!!_exceedMax, maxLengthMessage, minLengthMessage);

            if (validateAllFieldCriteria) {
              _context.next = 33;
              break;
            }

            return _context.abrupt("return", error);

          case 33:
            if (!(pattern && !isEmpty)) {
              _context.next = 39;
              break;
            }

            _getValueAndMessage5 = getValueAndMessage(pattern), patternValue = _getValueAndMessage5.value, patternMessage = _getValueAndMessage5.message;

            if (!(isRegex(patternValue) && !patternValue.test(value))) {
              _context.next = 39;
              break;
            }

            error[name] = Object.assign({
              type: INPUT_VALIDATION_RULES.pattern,
              message: patternMessage,
              ref: ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, patternMessage));

            if (validateAllFieldCriteria) {
              _context.next = 39;
              break;
            }

            return _context.abrupt("return", error);

          case 39:
            if (!validate) {
              _context.next = 72;
              break;
            }

            fieldValue = getFieldValue(fields, ref);
            validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;

            if (!isFunction(validate)) {
              _context.next = 53;
              break;
            }

            _context.next = 45;
            return validate(fieldValue);

          case 45:
            result = _context.sent;
            validateError = getValidateError(result, validateRef);

            if (!validateError) {
              _context.next = 51;
              break;
            }

            error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

            if (validateAllFieldCriteria) {
              _context.next = 51;
              break;
            }

            return _context.abrupt("return", error);

          case 51:
            _context.next = 72;
            break;

          case 53:
            if (!isObject(validate)) {
              _context.next = 72;
              break;
            }

            validationResult = {};
            _i = 0, _Object$entries = Object.entries(validate);

          case 56:
            if (!(_i < _Object$entries.length)) {
              _context.next = 68;
              break;
            }

            _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], validateFunction = _Object$entries$_i[1];

            if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
              _context.next = 60;
              break;
            }

            return _context.abrupt("break", 68);

          case 60:
            _context.next = 62;
            return validateFunction(fieldValue);

          case 62:
            validateResult = _context.sent;
            _validateError = getValidateError(validateResult, validateRef, key);

            if (_validateError) {
              validationResult = Object.assign(Object.assign({}, _validateError), appendErrorsCurry(key, _validateError.message));

              if (validateAllFieldCriteria) {
                error[name] = validationResult;
              }
            }

          case 65:
            _i++;
            _context.next = 56;
            break;

          case 68:
            if (isEmptyObject(validationResult)) {
              _context.next = 72;
              break;
            }

            error[name] = Object.assign({
              ref: validateRef
            }, validationResult);

            if (validateAllFieldCriteria) {
              _context.next = 72;
              break;
            }

            return _context.abrupt("return", error);

          case 72:
            return _context.abrupt("return", error);

          case 73:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateField(_x, _x2, _x3) {
    return _ref10.apply(this, arguments);
  };
}();

var parseErrorSchema = function parseErrorSchema(error, validateAllFieldCriteria) {
  return isArray(error.inner) ? error.inner.reduce(function (previous, _ref12) {
    var path = _ref12.path,
        message = _ref12.message,
        type = _ref12.type;
    return Object.assign(Object.assign({}, previous), path ? previous[path] && validateAllFieldCriteria ? _defineProperty({}, path, appendErrors(path, validateAllFieldCriteria, previous, type, message)) : _defineProperty({}, path, previous[path] || Object.assign({
      message: message,
      type: type
    }, validateAllFieldCriteria ? {
      types: _defineProperty({}, type, message || true)
    } : {})) : {});
  }, {}) : _defineProperty({}, error.path, {
    message: error.message,
    type: error.type
  });
};

function validateWithSchema(_x4, _x5, _x6, _x7, _x8) {
  return _validateWithSchema.apply(this, arguments);
}

function _validateWithSchema() {
  _validateWithSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(validationSchema, validateAllFieldCriteria, data, validationResolver, context) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!validationResolver) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return", validationResolver(data, context));

          case 2:
            _context8.prev = 2;
            _context8.next = 5;
            return validationSchema.validate(data, {
              abortEarly: false,
              context: context
            });

          case 5:
            _context8.t0 = _context8.sent;
            _context8.t1 = {};
            return _context8.abrupt("return", {
              values: _context8.t0,
              errors: _context8.t1
            });

          case 10:
            _context8.prev = 10;
            _context8.t2 = _context8["catch"](2);
            return _context8.abrupt("return", {
              values: {},
              errors: transformToNestObject(parseErrorSchema(_context8.t2, validateAllFieldCriteria))
            });

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[2, 10]]);
  }));
  return _validateWithSchema.apply(this, arguments);
}

var isPrimitive = function isPrimitive(value) {
  return isNullOrUndefined(value) || !isObjectType(value);
};

var getPath = function getPath(path, values) {
  var getInnerPath = function getInnerPath(value, key, isObject) {
    var pathWithIndex = isObject ? "".concat(path, ".").concat(key) : "".concat(path, "[").concat(key, "]");
    return isPrimitive(value) ? pathWithIndex : getPath(pathWithIndex, value);
  };

  return isArray(values) ? values.map(function (value, key) {
    return getInnerPath(value, key);
  }) : Object.entries(values).map(function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
        key = _ref17[0],
        value = _ref17[1];

    return getInnerPath(value, key, true);
  });
};

var getPath$1 = function getPath$1(parentPath, value) {
  return getPath(parentPath, value).flat(Infinity);
};

var assignWatchFields = function assignWatchFields(fieldValues, fieldName, watchFields, inputValue, isSingleField) {
  var value;
  watchFields.add(fieldName);

  if (isEmptyObject(fieldValues)) {
    value = undefined;
  } else if (!isUndefined(fieldValues[fieldName])) {
    value = fieldValues[fieldName];
    watchFields.add(fieldName);
  } else {
    value = get(transformToNestObject(fieldValues), fieldName);

    if (!isUndefined(value)) {
      getPath$1(fieldName, value).forEach(function (name) {
        return watchFields.add(name);
      });
    }
  }

  return isUndefined(value) ? isSingleField ? inputValue : get(inputValue, fieldName) : value;
};

var skipValidation = function skipValidation(_ref18) {
  var isOnChange = _ref18.isOnChange,
      hasError = _ref18.hasError,
      isBlurEvent = _ref18.isBlurEvent,
      isOnSubmit = _ref18.isOnSubmit,
      isReValidateOnSubmit = _ref18.isReValidateOnSubmit,
      isOnBlur = _ref18.isOnBlur,
      isReValidateOnBlur = _ref18.isReValidateOnBlur,
      isSubmitted = _ref18.isSubmitted;
  return isOnChange && isBlurEvent || isOnSubmit && isReValidateOnSubmit || isOnSubmit && !isSubmitted || isOnBlur && !isBlurEvent && !hasError || isReValidateOnBlur && !isBlurEvent && hasError || isReValidateOnSubmit && isSubmitted;
};

var getFieldArrayParentName = function getFieldArrayParentName(name) {
  return name.substring(0, name.indexOf('['));
};

var getFieldValueByName = function getFieldValueByName(fields, name) {
  var results = transformToNestObject(getFieldsValues(fields));
  return name ? get(results, name, results) : results;
};

function getIsFieldsDifferent(referenceArray, differenceArray) {
  var isMatch = false;

  if (!isArray(referenceArray) || !isArray(differenceArray) || referenceArray.length !== differenceArray.length) {
    return true;
  }

  for (var i = 0; i < referenceArray.length; i++) {
    if (isMatch) {
      break;
    }

    var dataA = referenceArray[i];
    var dataB = differenceArray[i];

    if (isUndefined(dataB) || Object.keys(dataA).length !== Object.keys(dataB).length) {
      isMatch = true;
      break;
    }

    for (var key in dataA) {
      if (dataA[key] !== dataB[key]) {
        isMatch = true;
        break;
      }
    }
  }

  return isMatch;
}

var isMatchFieldArrayName = function isMatchFieldArrayName(name, searchName) {
  return RegExp("^".concat(searchName, "[\\d+]").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
};

var isNameInFieldArray = function isNameInFieldArray(names, name) {
  return _toConsumableArray(names).some(function (current) {
    return isMatchFieldArrayName(name, current);
  });
};

var isSelectInput = function isSelectInput(element) {
  return element.type === "".concat(SELECT, "-one");
};

function onDomRemove(element, onDetachCallback) {
  var observer = new MutationObserver(function () {
    if (isDetached(element)) {
      observer.disconnect();
      onDetachCallback();
    }
  });
  observer.observe(window.document, {
    childList: true,
    subtree: true
  });
  return observer;
}

var modeChecker = function modeChecker(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange
  };
};

var isRadioOrCheckboxFunction = function isRadioOrCheckboxFunction(ref) {
  return isRadioInput(ref) || isCheckBoxInput(ref);
};

function useForm() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref19$mode = _ref19.mode,
      mode = _ref19$mode === void 0 ? VALIDATION_MODE.onSubmit : _ref19$mode,
      _ref19$reValidateMode = _ref19.reValidateMode,
      reValidateMode = _ref19$reValidateMode === void 0 ? VALIDATION_MODE.onChange : _ref19$reValidateMode,
      validationSchema = _ref19.validationSchema,
      validationResolver = _ref19.validationResolver,
      validationContext = _ref19.validationContext,
      _ref19$defaultValues = _ref19.defaultValues,
      defaultValues = _ref19$defaultValues === void 0 ? {} : _ref19$defaultValues,
      _ref19$submitFocusErr = _ref19.submitFocusError,
      submitFocusError = _ref19$submitFocusErr === void 0 ? true : _ref19$submitFocusErr,
      validateCriteriaMode = _ref19.validateCriteriaMode;

  var fieldsRef = useRef({});
  var errorsRef = useRef({});
  var touchedFieldsRef = useRef({});
  var fieldArrayDefaultValues = useRef({});
  var watchFieldsRef = useRef(new Set());
  var dirtyFieldsRef = useRef(new Set());
  var fieldsWithValidationRef = useRef(new Set());
  var validFieldsRef = useRef(new Set());
  var isValidRef = useRef(true);
  var defaultValuesRef = useRef(defaultValues);
  var defaultValuesAtRenderRef = useRef({});
  var isUnMount = useRef(false);
  var isWatchAllRef = useRef(false);
  var isSubmittedRef = useRef(false);
  var isDirtyRef = useRef(false);
  var submitCountRef = useRef(0);
  var isSubmittingRef = useRef(false);
  var handleChangeRef = useRef();
  var resetFieldArrayFunctionRef = useRef({});
  var validationContextRef = useRef(validationContext);
  var fieldArrayNamesRef = useRef(new Set());

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      render = _useState2[1];

  var _useRef$current = useRef(modeChecker(mode)).current,
      isOnBlur = _useRef$current.isOnBlur,
      isOnSubmit = _useRef$current.isOnSubmit,
      isOnChange = _useRef$current.isOnChange;
  var validateAllFieldCriteria = validateCriteriaMode === 'all';
  var isWindowUndefined = typeof window === UNDEFINED;
  var shouldValidateSchemaOrResolver = !!(validationSchema || validationResolver);
  var isWeb = typeof document !== UNDEFINED && !isWindowUndefined && !isUndefined(window.HTMLElement);
  var isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;
  var readFormStateRef = useRef({
    dirty: !isProxyEnabled,
    dirtyFields: !isProxyEnabled,
    isSubmitted: isOnSubmit,
    submitCount: !isProxyEnabled,
    touched: !isProxyEnabled,
    isSubmitting: !isProxyEnabled,
    isValid: !isProxyEnabled
  });
  var _useRef$current2 = useRef(modeChecker(reValidateMode)).current,
      isReValidateOnBlur = _useRef$current2.isOnBlur,
      isReValidateOnSubmit = _useRef$current2.isOnSubmit;
  validationContextRef.current = validationContext;
  var reRender = useCallback(function () {
    if (!isUnMount.current) {
      render({});
    }
  }, []);
  var shouldRenderBaseOnError = useCallback(function (name, error) {
    var shouldRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var shouldReRender = shouldRender || shouldRenderBasedOnError({
      errors: errorsRef.current,
      error: error,
      name: name,
      validFields: validFieldsRef.current,
      fieldsWithValidation: fieldsWithValidationRef.current
    });

    if (isEmptyObject(error)) {
      if (fieldsWithValidationRef.current.has(name) || shouldValidateSchemaOrResolver) {
        validFieldsRef.current.add(name);
        shouldReRender = shouldReRender || get(errorsRef.current, name);
      }

      errorsRef.current = unset(errorsRef.current, [name]);
    } else {
      var previousError = get(errorsRef.current, name);
      validFieldsRef.current.delete(name);
      shouldReRender = shouldReRender || (previousError ? !isSameError(previousError, error[name]) : true);
      set(errorsRef.current, name, error[name]);
    }

    if (shouldReRender && !isNullOrUndefined(shouldRender)) {
      reRender();
      return true;
    }
  }, [reRender, shouldValidateSchemaOrResolver]);
  var setFieldValue = useCallback(function (field, rawValue) {
    var ref = field.ref,
        options = field.options;
    var value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? '' : rawValue;

    if (isRadioInput(ref) && options) {
      options.forEach(function (_ref20) {
        var radioRef = _ref20.ref;
        return radioRef.checked = radioRef.value === value;
      });
    } else if (isFileInput(ref)) {
      if (isString(value)) {
        ref.value = value;
      } else {
        ref.files = value;
      }
    } else if (isMultipleSelect(ref)) {
      _toConsumableArray(ref.options).forEach(function (selectRef) {
        return selectRef.selected = value.includes(selectRef.value);
      });
    } else if (isCheckBoxInput(ref) && options) {
      options.length > 1 ? options.forEach(function (_ref21) {
        var checkboxRef = _ref21.ref;
        return checkboxRef.checked = value.includes(checkboxRef.value);
      }) : options[0].ref.checked = !!value;
    } else {
      ref.value = value;
    }
  }, [isWeb]);
  var setDirty = useCallback(function (name) {
    if (!fieldsRef.current[name] || !readFormStateRef.current.dirty && !readFormStateRef.current.dirtyFields) {
      return false;
    }

    var isFieldDirty = defaultValuesAtRenderRef.current[name] !== getFieldValue(fieldsRef.current, fieldsRef.current[name].ref);
    var isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);
    var previousDirtyFieldsLength = dirtyFieldsRef.current.size;

    if (isFieldArray) {
      var fieldArrayName = getFieldArrayParentName(name);
      isFieldDirty = getIsFieldsDifferent(getFieldValueByName(fieldsRef.current, fieldArrayName), get(defaultValuesRef.current, fieldArrayName));
    }

    var isDirtyChanged = (isFieldArray ? isDirtyRef.current : dirtyFieldsRef.current.has(name)) !== isFieldDirty;

    if (isFieldDirty) {
      dirtyFieldsRef.current.add(name);
    } else {
      dirtyFieldsRef.current.delete(name);
    }

    isDirtyRef.current = isFieldArray ? isFieldDirty : !!dirtyFieldsRef.current.size;
    return readFormStateRef.current.dirty ? isDirtyChanged : previousDirtyFieldsLength !== dirtyFieldsRef.current.size;
  }, []);
  var setInternalValues = useCallback(function (name, value, parentFieldName) {
    var isValueArray = isArray(value);

    for (var key in value) {
      var fieldName = "".concat(parentFieldName || name).concat(isValueArray ? "[".concat(key, "]") : ".".concat(key));
      var field = fieldsRef.current[fieldName];

      if (isObject(value[key])) {
        setInternalValues(name, value[key], fieldName);
      }

      if (field) {
        setFieldValue(field, value[key]);
        setDirty(fieldName);
      }
    }
  }, [setFieldValue, setDirty]);
  var setInternalValue = useCallback(function (name, value) {
    var field = fieldsRef.current[name];

    if (field) {
      setFieldValue(field, value);
      var output = setDirty(name);

      if (isBoolean(output)) {
        return output;
      }
    } else if (!isPrimitive(value)) {
      setInternalValues(name, value);
    }
  }, [setDirty, setFieldValue, setInternalValues]);
  var executeValidation = useCallback( /*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, skipReRender) {
      var field, _error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              field = fieldsRef.current[name];

              if (!field) {
                _context2.next = 7;
                break;
              }

              _context2.next = 4;
              return validateField(fieldsRef, validateAllFieldCriteria, field);

            case 4:
              _error = _context2.sent;
              shouldRenderBaseOnError(name, _error, skipReRender ? null : false);
              return _context2.abrupt("return", isEmptyObject(_error));

            case 7:
              return _context2.abrupt("return", false);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x9, _x10) {
      return _ref22.apply(this, arguments);
    };
  }(), [shouldRenderBaseOnError, validateAllFieldCriteria]);
  var executeSchemaOrResolverValidation = useCallback( /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
      var _yield$validateWithSc, errors, previousFormIsValid, _error2;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return validateWithSchema(validationSchema, validateAllFieldCriteria, getFieldValueByName(fieldsRef.current), validationResolver, validationContextRef.current);

            case 2:
              _yield$validateWithSc = _context3.sent;
              errors = _yield$validateWithSc.errors;
              previousFormIsValid = isValidRef.current;
              isValidRef.current = isEmptyObject(errors);

              if (isArray(payload)) {
                payload.forEach(function (name) {
                  var error = get(errors, name);

                  if (error) {
                    set(errorsRef.current, name, error);
                  } else {
                    unset(errorsRef.current, [name]);
                  }
                });
                reRender();
              } else {
                _error2 = get(errors, payload);
                shouldRenderBaseOnError(payload, _error2 ? _defineProperty({}, payload, _error2) : {}, previousFormIsValid !== isValidRef.current);
              }

              return _context3.abrupt("return", isEmptyObject(errorsRef.current));

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x11) {
      return _ref23.apply(this, arguments);
    };
  }(), [reRender, shouldRenderBaseOnError, validateAllFieldCriteria, validationResolver, validationSchema]);
  var triggerValidation = useCallback( /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
      var fields, result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              fields = payload || Object.keys(fieldsRef.current);

              if (!shouldValidateSchemaOrResolver) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return", executeSchemaOrResolverValidation(fields));

            case 3:
              if (!isArray(fields)) {
                _context5.next = 9;
                break;
              }

              _context5.next = 6;
              return Promise.all(fields.map( /*#__PURE__*/function () {
                var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return executeValidation(data, true);

                        case 2:
                          return _context4.abrupt("return", _context4.sent);

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x13) {
                  return _ref26.apply(this, arguments);
                };
              }()));

            case 6:
              result = _context5.sent;
              reRender();
              return _context5.abrupt("return", result.every(Boolean));

            case 9:
              _context5.next = 11;
              return executeValidation(fields);

            case 11:
              return _context5.abrupt("return", _context5.sent);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x12) {
      return _ref25.apply(this, arguments);
    };
  }(), [executeSchemaOrResolverValidation, executeValidation, reRender, shouldValidateSchemaOrResolver]);

  var isFieldWatched = function isFieldWatched(name) {
    return isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
  };

  function setValue(names, valueOrShouldValidate, shouldValidate) {
    var shouldRender = false;
    var isArrayValue = isArray(names);
    (isArrayValue ? names : [names]).forEach(function (name) {
      var isStringFieldName = isString(name);
      shouldRender = setInternalValue(isStringFieldName ? name : Object.keys(name)[0], isStringFieldName ? valueOrShouldValidate : Object.values(name)[0]) || isArrayValue ? true : isFieldWatched(name);
    });

    if (shouldRender || isArrayValue) {
      reRender();
    }

    if (shouldValidate || isArrayValue && valueOrShouldValidate) {
      triggerValidation(isArrayValue ? undefined : names);
    }
  }

  handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref27) {
      var type, target, name, fields, errors, field, currentError, error, isBlurEvent, shouldSkipValidation, shouldUpdateDirty, shouldRender, _yield$validateWithSc2, _errors, previousFormIsValid;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              type = _ref27.type, target = _ref27.target;
              name = target ? target.name : '';
              fields = fieldsRef.current;
              errors = errorsRef.current;
              field = fields[name];
              currentError = get(errors, name);

              if (field) {
                _context6.next = 8;
                break;
              }

              return _context6.abrupt("return");

            case 8:
              isBlurEvent = type === EVENTS.BLUR;
              shouldSkipValidation = skipValidation({
                hasError: !!currentError,
                isOnChange: isOnChange,
                isBlurEvent: isBlurEvent,
                isOnSubmit: isOnSubmit,
                isReValidateOnSubmit: isReValidateOnSubmit,
                isOnBlur: isOnBlur,
                isReValidateOnBlur: isReValidateOnBlur,
                isSubmitted: isSubmittedRef.current
              });
              shouldUpdateDirty = setDirty(name);
              shouldRender = isFieldWatched(name) || shouldUpdateDirty;

              if (isBlurEvent && !get(touchedFieldsRef.current, name) && readFormStateRef.current.touched) {
                set(touchedFieldsRef.current, name, true);
                shouldRender = true;
              }

              if (!shouldSkipValidation) {
                _context6.next = 15;
                break;
              }

              return _context6.abrupt("return", shouldRender && reRender());

            case 15:
              if (!shouldValidateSchemaOrResolver) {
                _context6.next = 26;
                break;
              }

              _context6.next = 18;
              return validateWithSchema(validationSchema, validateAllFieldCriteria, getFieldValueByName(fields), validationResolver, validationContextRef.current);

            case 18:
              _yield$validateWithSc2 = _context6.sent;
              _errors = _yield$validateWithSc2.errors;
              previousFormIsValid = isValidRef.current;
              isValidRef.current = isEmptyObject(_errors);
              error = get(_errors, name) ? _defineProperty({}, name, get(_errors, name)) : {};

              if (previousFormIsValid !== isValidRef.current) {
                shouldRender = true;
              }

              _context6.next = 29;
              break;

            case 26:
              _context6.next = 28;
              return validateField(fieldsRef, validateAllFieldCriteria, field);

            case 28:
              error = _context6.sent;

            case 29:
              if (!shouldRenderBaseOnError(name, error) && shouldRender) {
                reRender();
              }

            case 30:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x14) {
      return _ref28.apply(this, arguments);
    };
  }();
  var validateSchemaOrResolver = useCallback(function () {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fieldValues = isEmptyObject(defaultValuesRef.current) ? getFieldsValues(fieldsRef.current) : defaultValuesRef.current;
    validateWithSchema(validationSchema, validateAllFieldCriteria, transformToNestObject(Object.assign(Object.assign({}, fieldValues), values)), validationResolver, validationContextRef.current).then(function (_ref30) {
      var errors = _ref30.errors;
      var previousFormIsValid = isValidRef.current;
      isValidRef.current = isEmptyObject(errors);

      if (previousFormIsValid !== isValidRef.current) {
        reRender();
      }
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [reRender, validateAllFieldCriteria, validationResolver]);
  var removeFieldEventListener = useCallback(function (field, forceDelete) {
    if (handleChangeRef.current && field) {
      findRemovedFieldAndRemoveListener(fieldsRef.current, handleChangeRef.current, field, forceDelete);
    }
  }, []);
  var removeFieldEventListenerAndRef = useCallback(function (field, forceDelete) {
    if (!field || field && isNameInFieldArray(fieldArrayNamesRef.current, field.ref.name) && !forceDelete) {
      return;
    }

    removeFieldEventListener(field, forceDelete);
    var name = field.ref.name;
    errorsRef.current = unset(errorsRef.current, [name]);
    touchedFieldsRef.current = unset(touchedFieldsRef.current, [name]);
    defaultValuesAtRenderRef.current = unset(defaultValuesAtRenderRef.current, [name]);
    [dirtyFieldsRef, fieldsWithValidationRef, validFieldsRef, watchFieldsRef].forEach(function (data) {
      return data.current.delete(name);
    });

    if (readFormStateRef.current.isValid || readFormStateRef.current.touched) {
      reRender();

      if (shouldValidateSchemaOrResolver) {
        validateSchemaOrResolver();
      }
    }
  }, [reRender, shouldValidateSchemaOrResolver, validateSchemaOrResolver, removeFieldEventListener]);

  function clearError(name) {
    if (name) {
      unset(errorsRef.current, isArray(name) ? name : [name]);
    } else {
      errorsRef.current = {};
    }

    reRender();
  }

  var setInternalError = function setInternalError(_ref31) {
    var name = _ref31.name,
        type = _ref31.type,
        types = _ref31.types,
        message = _ref31.message,
        shouldRender = _ref31.shouldRender;
    var field = fieldsRef.current[name];

    if (!isSameError(get(errorsRef.current, name), {
      type: type,
      message: message,
      types: types
    })) {
      set(errorsRef.current, name, {
        type: type,
        types: types,
        message: message,
        ref: field ? field.ref : {},
        isManual: true
      });

      if (shouldRender) {
        reRender();
      }
    }
  };

  function setError(name) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var message = arguments.length > 2 ? arguments[2] : undefined;

    if (isString(name)) {
      setInternalError(Object.assign(Object.assign({
        name: name
      }, isObject(type) ? {
        types: type,
        type: ''
      } : {
        type: type,
        message: message
      }), {
        shouldRender: true
      }));
    } else if (isArray(name)) {
      name.forEach(function (error) {
        return setInternalError(Object.assign({}, error));
      });
      reRender();
    }
  }

  function watch(fieldNames, defaultValue) {
    var watchFields = watchFieldsRef.current;
    var isDefaultValueUndefined = isUndefined(defaultValue);
    var combinedDefaultValues = isDefaultValueUndefined ? defaultValuesRef.current : defaultValue;
    var fieldValues = getFieldsValues(fieldsRef.current, fieldNames);

    if (isString(fieldNames)) {
      return assignWatchFields(fieldValues, fieldNames, watchFields, isDefaultValueUndefined ? get(combinedDefaultValues, fieldNames) : defaultValue, true);
    }

    if (isArray(fieldNames)) {
      return fieldNames.reduce(function (previous, name) {
        return Object.assign(Object.assign({}, previous), _defineProperty({}, name, assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)));
      }, {});
    }

    isWatchAllRef.current = true;
    var result = !isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues;
    return fieldNames && fieldNames.nest ? transformToNestObject(result) : result;
  }

  function unregister(name) {
    if (fieldsRef.current) {
      (isArray(name) ? name : [name]).forEach(function (fieldName) {
        return removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
      });
    }
  }

  function registerFieldsRef(ref) {
    var validateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!ref.name) {
      // eslint-disable-next-line no-console
      return console.warn('Missing name @', ref);
    }

    var name = ref.name,
        type = ref.type,
        value = ref.value;
    var fieldRefAndValidationOptions = Object.assign({
      ref: ref
    }, validateOptions);
    var fields = fieldsRef.current;
    var isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
    var field = fields[name];
    var isEmptyDefaultValue = true;
    var isFieldArray;
    var defaultValue;

    if (isRadioOrCheckbox ? field && isArray(field.options) && field.options.filter(Boolean).find(function (option) {
      return value === option.ref.value && option.ref === ref;
    }) : field && ref === field.ref) {
      fields[name] = Object.assign(Object.assign({}, field), validateOptions);
      return;
    }

    if (type) {
      var mutationWatcher = onDomRemove(ref, function () {
        return removeFieldEventListenerAndRef(field);
      });
      field = isRadioOrCheckbox ? Object.assign({
        options: [].concat(_toConsumableArray(field && field.options || []), [{
          ref: ref,
          mutationWatcher: mutationWatcher
        }]),
        ref: {
          type: type,
          name: name
        }
      }, validateOptions) : Object.assign(Object.assign({}, fieldRefAndValidationOptions), {
        mutationWatcher: mutationWatcher
      });
    } else {
      field = fieldRefAndValidationOptions;
    }

    fields[name] = field;

    if (!isEmptyObject(defaultValuesRef.current)) {
      defaultValue = get(defaultValuesRef.current, name);
      isEmptyDefaultValue = isUndefined(defaultValue);
      isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);

      if (!isEmptyDefaultValue && !isFieldArray) {
        setFieldValue(field, defaultValue);
      }
    }

    if (shouldValidateSchemaOrResolver && !isFieldArray && readFormStateRef.current.isValid) {
      validateSchemaOrResolver();
    } else if (!isEmptyObject(validateOptions)) {
      fieldsWithValidationRef.current.add(name);

      if (!isOnSubmit && readFormStateRef.current.isValid) {
        validateField(fieldsRef, validateAllFieldCriteria, field).then(function (error) {
          var previousFormIsValid = isValidRef.current;
          isEmptyObject(error) ? validFieldsRef.current.add(name) : isValidRef.current = false;

          if (previousFormIsValid !== isValidRef.current) {
            reRender();
          }
        });
      }
    }

    if (!defaultValuesAtRenderRef.current[name] && !(isFieldArray && isEmptyDefaultValue)) {
      defaultValuesAtRenderRef.current[name] = isEmptyDefaultValue ? getFieldValue(fields, field.ref) : defaultValue;
    }

    if (type) {
      attachEventListeners({
        field: isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field,
        isRadioOrCheckbox: isRadioOrCheckbox || isSelectInput(ref),
        handleChange: handleChangeRef.current
      });
    }
  }

  function register(refOrValidationOptions, validationOptions) {
    if (isWindowUndefined) {
      return;
    }

    if (isString(refOrValidationOptions)) {
      registerFieldsRef({
        name: refOrValidationOptions
      }, validationOptions);
      return;
    }

    if (isObject(refOrValidationOptions) && 'name' in refOrValidationOptions) {
      registerFieldsRef(refOrValidationOptions, validationOptions);
      return;
    }

    return function (ref) {
      return ref && registerFieldsRef(ref, refOrValidationOptions);
    };
  }

  var handleSubmit = useCallback(function (callback) {
    return /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
        var fieldErrors, fields, fieldValues, _yield$validateWithSc3, errors, values, _i2, _Object$values, field, _name, fieldError;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (e) {
                  e.preventDefault();
                  e.persist();
                }

                fieldErrors = {};
                fields = fieldsRef.current;
                fieldValues = getFieldsValues(fields);

                if (readFormStateRef.current.isSubmitting) {
                  isSubmittingRef.current = true;
                  reRender();
                }

                _context7.prev = 5;

                if (!shouldValidateSchemaOrResolver) {
                  _context7.next = 17;
                  break;
                }

                _context7.next = 9;
                return validateWithSchema(validationSchema, validateAllFieldCriteria, transformToNestObject(fieldValues), validationResolver, validationContextRef.current);

              case 9:
                _yield$validateWithSc3 = _context7.sent;
                errors = _yield$validateWithSc3.errors;
                values = _yield$validateWithSc3.values;
                errorsRef.current = errors;
                fieldErrors = errors;
                fieldValues = values;
                _context7.next = 29;
                break;

              case 17:
                _i2 = 0, _Object$values = Object.values(fields);

              case 18:
                if (!(_i2 < _Object$values.length)) {
                  _context7.next = 29;
                  break;
                }

                field = _Object$values[_i2];

                if (!field) {
                  _context7.next = 26;
                  break;
                }

                _name = field.ref.name;
                _context7.next = 24;
                return validateField(fieldsRef, validateAllFieldCriteria, field);

              case 24:
                fieldError = _context7.sent;

                if (fieldError[_name]) {
                  set(fieldErrors, _name, fieldError[_name]);
                  validFieldsRef.current.delete(_name);
                } else {
                  if (fieldsWithValidationRef.current.has(_name)) {
                    validFieldsRef.current.add(_name);
                  }
                }

              case 26:
                _i2++;
                _context7.next = 18;
                break;

              case 29:
                if (!isEmptyObject(fieldErrors)) {
                  _context7.next = 36;
                  break;
                }

                errorsRef.current = {};
                reRender();
                _context7.next = 34;
                return callback(transformToNestObject(fieldValues), e);

              case 34:
                _context7.next = 38;
                break;

              case 36:
                errorsRef.current = fieldErrors;

                if (submitFocusError && isWeb) {
                  focusOnErrorField(fields, fieldErrors);
                }

              case 38:
                _context7.prev = 38;
                isSubmittedRef.current = true;
                isSubmittingRef.current = false;
                submitCountRef.current = submitCountRef.current + 1;
                reRender();
                return _context7.finish(38);

              case 44:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[5,, 38, 44]]);
      }));

      return function (_x15) {
        return _ref32.apply(this, arguments);
      };
    }();
  }, [isWeb, reRender, shouldValidateSchemaOrResolver, submitFocusError, validateAllFieldCriteria, validationResolver, validationSchema]);

  var resetRefs = function resetRefs(_ref33) {
    var errors = _ref33.errors,
        dirty = _ref33.dirty,
        isSubmitted = _ref33.isSubmitted,
        touched = _ref33.touched,
        isValid = _ref33.isValid,
        submitCount = _ref33.submitCount,
        dirtyFields = _ref33.dirtyFields;
    fieldsRef.current = {};

    if (!errors) {
      errorsRef.current = {};
    }

    if (!touched) {
      touchedFieldsRef.current = {};
    }

    if (!isValid) {
      validFieldsRef.current = new Set();
      fieldsWithValidationRef.current = new Set();
      isValidRef.current = true;
    }

    if (!dirty) {
      isDirtyRef.current = false;
    }

    if (!dirtyFields) {
      dirtyFieldsRef.current = new Set();
    }

    if (!isSubmitted) {
      isSubmittedRef.current = false;
    }

    if (!submitCount) {
      submitCountRef.current = 0;
    }

    defaultValuesAtRenderRef.current = {};
    fieldArrayDefaultValues.current = {};
    watchFieldsRef.current = new Set();
    isWatchAllRef.current = false;
  };

  var reset = function reset(values) {
    var omitResetState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (isWeb) {
      for (var _i3 = 0, _Object$values2 = Object.values(fieldsRef.current); _i3 < _Object$values2.length; _i3++) {
        var field = _Object$values2[_i3];

        if (field) {
          var _ref34 = field.ref,
              options = field.options;
          var inputRef = isRadioOrCheckboxFunction(_ref34) && isArray(options) ? options[0].ref : _ref34;

          if (isHTMLElement(inputRef)) {
            try {
              inputRef.closest('form').reset();
              break;
            } catch (_a) {}
          }
        }
      }
    }

    if (values) {
      defaultValuesRef.current = values;
    }

    Object.values(resetFieldArrayFunctionRef.current).forEach(function (resetFieldArray) {
      return isFunction(resetFieldArray) && resetFieldArray();
    });
    resetRefs(omitResetState);
    reRender();
  };

  function getValues(payload) {
    if (isString(payload)) {
      return fieldsRef.current[payload] ? getFieldValue(fieldsRef.current, fieldsRef.current[payload].ref) : get(defaultValuesRef.current, payload);
    }

    var fieldValues = getFieldsValues(fieldsRef.current);
    var outputValues = isEmptyObject(fieldValues) ? defaultValuesRef.current : fieldValues;
    return payload && payload.nest ? transformToNestObject(outputValues) : outputValues;
  }

  useEffect(function () {
    return function () {
      isUnMount.current = true;
      fieldsRef.current && process.env.NODE_ENV === 'production' && Object.values(fieldsRef.current).forEach(function (field) {
        return removeFieldEventListenerAndRef(field, true);
      });
    };
  }, [removeFieldEventListenerAndRef]);

  if (!shouldValidateSchemaOrResolver) {
    isValidRef.current = validFieldsRef.current.size >= fieldsWithValidationRef.current.size && isEmptyObject(errorsRef.current);
  }

  var formState = {
    dirty: isDirtyRef.current,
    dirtyFields: dirtyFieldsRef.current,
    isSubmitted: isSubmittedRef.current,
    submitCount: submitCountRef.current,
    touched: touchedFieldsRef.current,
    isSubmitting: isSubmittingRef.current,
    isValid: isOnSubmit ? isSubmittedRef.current && isEmptyObject(errorsRef.current) : isValidRef.current
  };
  var commonProps = {
    triggerValidation: triggerValidation,
    setValue: useCallback(setValue, [reRender, setInternalValue, triggerValidation]),
    register: useCallback(register, [defaultValuesRef.current, defaultValuesAtRenderRef.current]),
    unregister: useCallback(unregister, []),
    getValues: useCallback(getValues, []),
    formState: isProxyEnabled ? new Proxy(formState, {
      get: function get(obj, prop) {
        if (prop in obj) {
          readFormStateRef.current[prop] = true;
          return obj[prop];
        }

        return undefined;
      }
    }) : formState
  };
  var control = Object.assign(Object.assign(Object.assign({
    removeFieldEventListener: removeFieldEventListener,
    reRender: reRender
  }, shouldValidateSchemaOrResolver ? {
    validateSchemaIsValid: validateSchemaOrResolver
  } : {}), {
    mode: {
      isOnBlur: isOnBlur,
      isOnSubmit: isOnSubmit,
      isOnChange: isOnChange
    },
    reValidateMode: {
      isReValidateOnBlur: isReValidateOnBlur,
      isReValidateOnSubmit: isReValidateOnSubmit
    },
    errorsRef: errorsRef,
    touchedFieldsRef: touchedFieldsRef,
    fieldsRef: fieldsRef,
    isWatchAllRef: isWatchAllRef,
    watchFieldsRef: watchFieldsRef,
    resetFieldArrayFunctionRef: resetFieldArrayFunctionRef,
    fieldArrayDefaultValues: fieldArrayDefaultValues,
    validFieldsRef: validFieldsRef,
    dirtyFieldsRef: dirtyFieldsRef,
    fieldsWithValidationRef: fieldsWithValidationRef,
    fieldArrayNamesRef: fieldArrayNamesRef,
    isDirtyRef: isDirtyRef,
    readFormStateRef: readFormStateRef,
    defaultValuesRef: defaultValuesRef
  }), commonProps);
  return Object.assign({
    watch: watch,
    control: control,
    handleSubmit: handleSubmit,
    reset: useCallback(reset, []),
    clearError: useCallback(clearError, []),
    setError: useCallback(setError, []),
    errors: errorsRef.current
  }, commonProps);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var FormGlobalContext = createContext(null);

function useFormContext() {
  return useContext(FormGlobalContext);
}

function FormContext(_a) {
  var children = _a.children,
      formState = _a.formState,
      errors = _a.errors,
      restMethods = __rest(_a, ["children", "formState", "errors"]);

  return createElement(FormGlobalContext.Provider, {
    value: Object.assign(Object.assign({}, restMethods), {
      formState: formState,
      errors: errors
    })
  }, children);
}

var generateId = function generateId() {
  var d = typeof performance === UNDEFINED ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

var appendId = function appendId(value, keyName) {
  return Object.assign(_defineProperty({}, keyName, generateId()), isObject(value) ? value : {
    value: value
  });
};

var mapIds = function mapIds(data, keyName) {
  return (isArray(data) ? data : []).map(function (value) {
    return appendId(value, keyName);
  });
};

var getSortRemovedItems = function getSortRemovedItems(indexes, removeIndexes) {
  var updatedIndexes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var notFoundIndexes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  var _iterator = _createForOfIteratorHelper(removeIndexes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var removeIndex = _step.value;

      if (indexes.indexOf(removeIndex) < 0) {
        notFoundIndexes.push(removeIndex);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(indexes.sort()),
      _step2;

  try {
    var _loop2 = function _loop2() {
      var index = _step2.value;

      if (removeIndexes.indexOf(index) > -1) {
        updatedIndexes.push(-1);
        count++;
      } else {
        updatedIndexes.push(index - count - (notFoundIndexes.length ? notFoundIndexes.map(function (notFoundIndex) {
          return notFoundIndex < index;
        }).filter(Boolean).length : 0));
      }
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return updatedIndexes;
};

var removeAt = function removeAt(data, index) {
  return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(data.slice(index + 1)));
};

function removeAtIndexes(data, index) {
  var k = -1;

  while (++k < data.length) {
    if (index.indexOf(k) >= 0) {
      delete data[k];
    }
  }

  return data.filter(Boolean);
}

var removeArrayAt = function removeArrayAt(data, index) {
  return isUndefined(index) ? [] : isArray(index) ? removeAtIndexes(data, index) : removeAt(data, index);
};

var moveArrayAt = function moveArrayAt(data, from, to) {
  return isArray(data) ? data.splice(to, 0, data.splice(from, 1)[0]) : [];
};

var swapArrayAt = function swapArrayAt(data, indexA, indexB) {
  var temp = [data[indexB], data[indexA]];
  data[indexA] = temp[0];
  data[indexB] = temp[1];
};

function prepend(data, value) {
  return [].concat(_toConsumableArray(isArray(value) ? value : [value || null]), _toConsumableArray(data));
}

function insert(data, index, value) {
  return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(isArray(value) ? value : [value || null]), _toConsumableArray(data.slice(index)));
}

var fillEmptyArray = function fillEmptyArray(value) {
  return isArray(value) ? Array(value.length).fill(null) : null;
};

var useFieldArray = function useFieldArray(_ref35) {
  var control = _ref35.control,
      name = _ref35.name,
      _ref35$keyName = _ref35.keyName,
      keyName = _ref35$keyName === void 0 ? 'id' : _ref35$keyName;
  var methods = useFormContext();

  var _ref36 = control || methods.control,
      isWatchAllRef = _ref36.isWatchAllRef,
      resetFieldArrayFunctionRef = _ref36.resetFieldArrayFunctionRef,
      fieldArrayNamesRef = _ref36.fieldArrayNamesRef,
      reRender = _ref36.reRender,
      fieldsRef = _ref36.fieldsRef,
      getValues = _ref36.getValues,
      defaultValuesRef = _ref36.defaultValuesRef,
      removeFieldEventListener = _ref36.removeFieldEventListener,
      errorsRef = _ref36.errorsRef,
      dirtyFieldsRef = _ref36.dirtyFieldsRef,
      isDirtyRef = _ref36.isDirtyRef,
      touchedFieldsRef = _ref36.touchedFieldsRef,
      readFormStateRef = _ref36.readFormStateRef,
      watchFieldsRef = _ref36.watchFieldsRef,
      validFieldsRef = _ref36.validFieldsRef,
      fieldsWithValidationRef = _ref36.fieldsWithValidationRef,
      fieldArrayDefaultValues = _ref36.fieldArrayDefaultValues,
      validateSchemaIsValid = _ref36.validateSchemaIsValid;

  var getDefaultValues = function getDefaultValues() {
    return _toConsumableArray(get(fieldArrayDefaultValues.current[getFieldArrayParentName(name)] ? fieldArrayDefaultValues.current : defaultValuesRef.current, name, []));
  };

  var memoizedDefaultValues = useRef(getDefaultValues());

  var _useState3 = useState(mapIds(memoizedDefaultValues.current, keyName)),
      _useState4 = _slicedToArray(_useState3, 2),
      fields = _useState4[0],
      setField = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDeleted = _useState6[0],
      setIsDeleted = _useState6[1];

  var allFields = useRef(fields);
  var isNameKey = isKey(name);
  allFields.current = fields;

  if (isNameKey) {
    fieldArrayDefaultValues.current[name] = memoizedDefaultValues.current;
  }

  var appendValueWithKey = function appendValueWithKey(values) {
    return values.map(function (value) {
      return appendId(value, keyName);
    });
  };

  var setFieldAndValidState = function setFieldAndValidState(fieldsValues) {
    setField(fieldsValues);

    if (readFormStateRef.current.isValid && validateSchemaIsValid) {
      validateSchemaIsValid(_defineProperty({}, name, fieldsValues));
    }
  };

  var modifyDirtyFields = function modifyDirtyFields() {
    var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        shouldRender = _ref37.shouldRender,
        isRemove = _ref37.isRemove,
        isPrePend = _ref37.isPrePend,
        index = _ref37.index,
        _ref37$value = _ref37.value,
        value = _ref37$value === void 0 ? {} : _ref37$value;

    var render = shouldRender;
    var values = isArray(value) ? value : [value];

    if (readFormStateRef.current.dirty) {
      var dirtyFieldIndexesAndValues = {};

      if (isPrePend || isRemove) {
        var _iterator3 = _createForOfIteratorHelper(_toConsumableArray(dirtyFieldsRef.current).sort()),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var dirtyField = _step3.value;

            if (isMatchFieldArrayName(dirtyField, name)) {
              var matchedIndexes = dirtyField.match(REGEX_ARRAY_FIELD_INDEX);

              if (matchedIndexes) {
                var matchIndex = +matchedIndexes[matchedIndexes.length - 1];

                if (dirtyFieldIndexesAndValues[matchIndex]) {
                  dirtyFieldIndexesAndValues[matchIndex].push(dirtyField);
                } else {
                  dirtyFieldIndexesAndValues[matchIndex] = [dirtyField];
                }
              }

              dirtyFieldsRef.current.delete(dirtyField);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      if (!isUndefined(index) || isPrePend) {
        var updatedDirtyFieldIndexes = isUndefined(index) ? [] : getSortRemovedItems(Object.keys(dirtyFieldIndexesAndValues).map(function (i) {
          return +i;
        }), isArray(index) ? index : [index]);
        Object.values(dirtyFieldIndexesAndValues).forEach(function (values, index) {
          var updateIndex = isPrePend ? 0 : updatedDirtyFieldIndexes[index];

          if (updateIndex > -1) {
            var _iterator4 = _createForOfIteratorHelper(values),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _value = _step4.value;

                var _matchedIndexes = _value.match(REGEX_ARRAY_FIELD_INDEX);

                if (_matchedIndexes) {
                  dirtyFieldsRef.current.add(_value.replace(/[\d+]([^[\d+]+)$/, "".concat(isPrePend ? +_matchedIndexes[_matchedIndexes.length - 1] + values.length : updateIndex, "$1")));
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        });
      }

      if (!isRemove) {
        values.forEach(function (fieldValue, index) {
          return Object.keys(fieldValue).forEach(function (key) {
            return dirtyFieldsRef.current.add("".concat(name, "[").concat(isPrePend ? index : allFields.current.length + index, "].").concat(key));
          });
        });
        isDirtyRef.current = true;
      }

      render = true;
    }

    if (render && !isWatchAllRef.current) {
      reRender();
    }
  };

  var resetFields = function resetFields(flagOrFields) {
    if (readFormStateRef.current.dirty) {
      isDirtyRef.current = isUndefined(flagOrFields) ? true : getIsFieldsDifferent(flagOrFields, defaultValuesRef.current[name] || []);
    }

    for (var key in fieldsRef.current) {
      if (isMatchFieldArrayName(key, name) && fieldsRef.current[key]) {
        removeFieldEventListener(fieldsRef.current[key], true);
      }
    }
  };

  var mapCurrentFieldsValueWithState = function mapCurrentFieldsValueWithState() {
    var currentFieldsValue = get(getValues({
      nest: true
    }), name);

    if (isArray(currentFieldsValue)) {
      for (var i = 0; i < currentFieldsValue.length; i++) {
        allFields.current[i] = Object.assign(Object.assign({}, allFields.current[i]), currentFieldsValue[i]);
      }
    }
  };

  var append = function append(value) {
    setFieldAndValidState([].concat(_toConsumableArray(allFields.current), _toConsumableArray(isArray(value) ? appendValueWithKey(value) : [appendId(value, keyName)])));
    modifyDirtyFields({
      value: value
    });
  };

  var prepend$1 = function prepend$1(value) {
    var shouldRender = false;
    resetFields();
    setFieldAndValidState(prepend(allFields.current, isArray(value) ? appendValueWithKey(value) : [appendId(value, keyName)]));

    if (errorsRef.current[name]) {
      errorsRef.current[name] = prepend(errorsRef.current[name], fillEmptyArray(value));
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      touchedFieldsRef.current[name] = prepend(touchedFieldsRef.current[name], fillEmptyArray(value));
      shouldRender = true;
    }

    modifyDirtyFields({
      shouldRender: shouldRender,
      isPrePend: true,
      value: value
    });
  };

  var remove = function remove(index) {
    var shouldRender = false;
    var isIndexUndefined = isUndefined(index);

    if (!isIndexUndefined) {
      mapCurrentFieldsValueWithState();
    }

    resetFields(removeArrayAt(getFieldValueByName(fieldsRef.current, name), index));
    setFieldAndValidState(removeArrayAt(allFields.current, index));
    setIsDeleted(true);

    if (errorsRef.current[name]) {
      errorsRef.current[name] = removeArrayAt(errorsRef.current[name], index);

      if (!errorsRef.current[name].filter(Boolean).length) {
        delete errorsRef.current[name];
      }
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      touchedFieldsRef.current[name] = removeArrayAt(touchedFieldsRef.current[name], index);
      shouldRender = true;
    }

    if (readFormStateRef.current.isValid && !validateSchemaIsValid) {
      var fieldIndex = -1;
      var isFound = false;

      var _isIndexUndefined = isUndefined(index);

      while (fieldIndex++ < fields.length) {
        var isLast = fieldIndex === fields.length - 1;
        var isCurrentIndex = (isArray(index) ? index : [index]).indexOf(fieldIndex) >= 0;

        if (isCurrentIndex || _isIndexUndefined) {
          isFound = true;
        }

        if (!isFound) {
          continue;
        }

        for (var key in fields[fieldIndex]) {
          var currentFieldName = "".concat(name, "[").concat(fieldIndex, "].").concat(key);

          if (isCurrentIndex || isLast || _isIndexUndefined) {
            validFieldsRef.current.delete(currentFieldName);
            fieldsWithValidationRef.current.delete(currentFieldName);
          } else {
            var previousFieldName = "".concat(name, "[").concat(fieldIndex - 1, "].").concat(key);

            if (validFieldsRef.current.has(currentFieldName)) {
              validFieldsRef.current.add(previousFieldName);
            }

            if (fieldsWithValidationRef.current.has(currentFieldName)) {
              fieldsWithValidationRef.current.add(previousFieldName);
            }
          }
        }
      }
    }

    modifyDirtyFields({
      shouldRender: shouldRender,
      isRemove: true,
      index: index
    });
  };

  var insert$1 = function insert$1(index, value) {
    mapCurrentFieldsValueWithState();
    resetFields(insert(getFieldValueByName(fieldsRef.current, name), index));
    setFieldAndValidState(insert(allFields.current, index, isArray(value) ? appendValueWithKey(value) : [appendId(value, keyName)]));

    if (errorsRef.current[name]) {
      errorsRef.current[name] = insert(errorsRef.current[name], index, fillEmptyArray(value));
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      touchedFieldsRef.current[name] = insert(touchedFieldsRef.current[name], index, fillEmptyArray(value));
      reRender();
    }
  };

  var swap = function swap(indexA, indexB) {
    mapCurrentFieldsValueWithState();
    var fieldValues = getFieldValueByName(fieldsRef.current, name);
    swapArrayAt(fieldValues, indexA, indexB);
    resetFields(fieldValues);
    swapArrayAt(allFields.current, indexA, indexB);
    setFieldAndValidState(_toConsumableArray(allFields.current));

    if (errorsRef.current[name]) {
      swapArrayAt(errorsRef.current[name], indexA, indexB);
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      swapArrayAt(touchedFieldsRef.current[name], indexA, indexB);
      reRender();
    }
  };

  var move = function move(from, to) {
    mapCurrentFieldsValueWithState();
    var fieldValues = getFieldValueByName(fieldsRef.current, name);
    moveArrayAt(fieldValues, from, to);
    resetFields(fieldValues);
    moveArrayAt(allFields.current, from, to);
    setFieldAndValidState(_toConsumableArray(allFields.current));

    if (errorsRef.current[name]) {
      moveArrayAt(errorsRef.current[name], from, to);
    }

    if (readFormStateRef.current.touched && touchedFieldsRef.current[name]) {
      moveArrayAt(touchedFieldsRef.current[name], from, to);
      reRender();
    }
  };

  var reset = function reset() {
    resetFields();
    memoizedDefaultValues.current = getDefaultValues();
    setField(mapIds(memoizedDefaultValues.current, keyName));
  };

  useEffect(function () {
    if (isNameKey && isDeleted && fieldArrayDefaultValues.current[name] && fields.length < fieldArrayDefaultValues.current[name].length) {
      fieldArrayDefaultValues.current[name].pop();
    }
  }, [fields, name, fieldArrayDefaultValues, isDeleted, isNameKey]);
  useEffect(function () {
    if (isWatchAllRef && isWatchAllRef.current) {
      reRender();
    } else if (watchFieldsRef) {
      var _iterator5 = _createForOfIteratorHelper(watchFieldsRef.current),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var watchField = _step5.value;

          if (watchField.startsWith(name)) {
            reRender();
            break;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, [fields, name, reRender, watchFieldsRef, isWatchAllRef]);
  useEffect(function () {
    var resetFunctions = resetFieldArrayFunctionRef.current;
    var fieldArrayNames = fieldArrayNamesRef.current;
    fieldArrayNames.add(name);
    resetFunctions[name] = reset;
    return function () {
      resetFields();
      delete resetFunctions[name];
      fieldArrayNames.delete(name);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    swap: useCallback(swap, [name]),
    move: useCallback(move, [name]),
    prepend: useCallback(prepend$1, [name]),
    append: useCallback(append, [name]),
    remove: useCallback(remove, [fields, name]),
    insert: useCallback(insert$1, [name]),
    fields: fields
  };
};

var getInputValue = function getInputValue(event, isCheckboxInput) {
  return isPrimitive(event) || !isObject(event.target) || isObject(event.target) && !event.type ? event : isCheckboxInput || isUndefined(event.target.value) ? event.target.checked : event.target.value;
};

var Controller = function Controller(_a) {
  var name = _a.name,
      rules = _a.rules,
      InnerComponent = _a.as,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      _a$onChangeName = _a.onChangeName,
      onChangeName = _a$onChangeName === void 0 ? VALIDATION_MODE.onChange : _a$onChangeName,
      _a$onBlurName = _a.onBlurName,
      onBlurName = _a$onBlurName === void 0 ? VALIDATION_MODE.onBlur : _a$onBlurName,
      valueName = _a.valueName,
      defaultValue = _a.defaultValue,
      control = _a.control,
      onFocus = _a.onFocus,
      rest = __rest(_a, ["name", "rules", "as", "onBlur", "onChange", "onChangeName", "onBlurName", "valueName", "defaultValue", "control", "onFocus"]);

  var methods = useFormContext();

  var _ref38 = control || methods.control,
      defaultValuesRef = _ref38.defaultValuesRef,
      setValue = _ref38.setValue,
      register = _ref38.register,
      unregister = _ref38.unregister,
      errorsRef = _ref38.errorsRef,
      removeFieldEventListener = _ref38.removeFieldEventListener,
      triggerValidation = _ref38.triggerValidation,
      _ref38$mode = _ref38.mode,
      isOnSubmit = _ref38$mode.isOnSubmit,
      isOnBlur = _ref38$mode.isOnBlur,
      isOnChange = _ref38$mode.isOnChange,
      _ref38$reValidateMode = _ref38.reValidateMode,
      isReValidateOnBlur = _ref38$reValidateMode.isReValidateOnBlur,
      isReValidateOnSubmit = _ref38$reValidateMode.isReValidateOnSubmit,
      isSubmitted = _ref38.formState.isSubmitted,
      touchedFieldsRef = _ref38.touchedFieldsRef,
      readFormStateRef = _ref38.readFormStateRef,
      reRender = _ref38.reRender,
      fieldsRef = _ref38.fieldsRef,
      fieldArrayNamesRef = _ref38.fieldArrayNamesRef;

  var _useState7 = useState(isUndefined(defaultValue) ? get(defaultValuesRef.current, name) : defaultValue),
      _useState8 = _slicedToArray(_useState7, 2),
      value = _useState8[0],
      setInputStateValue = _useState8[1];

  var valueRef = useRef(value);
  var isCheckboxInput = isBoolean(value);
  var shouldReValidateOnBlur = isOnBlur || isReValidateOnBlur;
  var rulesRef = useRef(rules);
  var onFocusRef = useRef(onFocus);
  var isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);
  rulesRef.current = rules;

  var shouldValidate = function shouldValidate() {
    return !skipValidation({
      hasError: !!get(errorsRef.current, name),
      isOnBlur: isOnBlur,
      isOnSubmit: isOnSubmit,
      isOnChange: isOnChange,
      isReValidateOnBlur: isReValidateOnBlur,
      isReValidateOnSubmit: isReValidateOnSubmit,
      isSubmitted: isSubmitted
    });
  };

  var commonTask = function commonTask(event) {
    var data = getInputValue(event, isCheckboxInput);
    setInputStateValue(data);
    valueRef.current = data;
    return data;
  };

  var eventWrapper = function eventWrapper(event) {
    return function () {
      for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      return setValue(name, commonTask(event(arg)), shouldValidate());
    };
  };

  var handleChange = function handleChange(event) {
    var data = commonTask(event);
    setValue(name, data, shouldValidate());
  };

  var registerField = useCallback(function () {
    if (!isNotFieldArray) {
      removeFieldEventListener(fieldsRef.current[name], true);
    }

    register(Object.defineProperty({
      name: name,
      focus: onFocusRef.current
    }, VALUE, {
      set: function set(data) {
        setInputStateValue(data);
        valueRef.current = data;
      },
      get: function get() {
        return valueRef.current;
      }
    }), rulesRef.current);
  }, [isNotFieldArray, fieldsRef, rulesRef, name, onFocusRef, register, removeFieldEventListener]);
  useEffect(function () {
    return function () {
      !isNameInFieldArray(fieldArrayNamesRef.current, name) && unregister(name);
    };
  }, [unregister, name, fieldArrayNamesRef]);
  useEffect(function () {
    registerField();
  }, [registerField]); // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (!fieldsRef.current[name]) {
      registerField();

      if (isNotFieldArray) {
        setInputStateValue(isUndefined(defaultValue) ? get(defaultValuesRef.current, name) : defaultValue);
      }
    }
  });
  var props = Object.assign(Object.assign(Object.assign(Object.assign({
    name: name
  }, rest), onChange ? _defineProperty({}, onChangeName, eventWrapper(onChange)) : _defineProperty({}, onChangeName, handleChange)), _defineProperty({}, onBlurName, function () {
    if (onBlur) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      onBlur(args);
    }

    if (readFormStateRef.current.touched && !get(touchedFieldsRef.current, name)) {
      set(touchedFieldsRef.current, name, true);
      reRender();
    }

    if (shouldReValidateOnBlur) {
      triggerValidation(name);
    }
  })), _defineProperty({}, valueName || (isCheckboxInput ? 'checked' : VALUE), value));
  return isValidElement(InnerComponent) ? cloneElement(InnerComponent, props) : createElement(InnerComponent, props);
};

var ErrorMessage = function ErrorMessage(_a) {
  var InnerComponent = _a.as,
      errors = _a.errors,
      name = _a.name,
      message = _a.message,
      children = _a.children,
      rest = __rest(_a, ["as", "errors", "name", "message", "children"]);

  var methods = useFormContext();
  var error = get(errors || methods.errors, name);

  if (!error) {
    return null;
  }

  var messageFromRegister = error.message,
      types = error.types;
  var props = Object.assign(Object.assign({}, InnerComponent ? rest : {}), {
    children: children ? children({
      message: messageFromRegister || message,
      messages: types
    }) : messageFromRegister || message
  });
  return InnerComponent ? isValidElement(InnerComponent) ? cloneElement(InnerComponent, props) : createElement(InnerComponent, props) : createElement(Fragment, Object.assign({}, props));
};

export { Controller, ErrorMessage, FormContext, useFieldArray, useForm, useFormContext };